import React from "react";
import { connect } from "react-redux";
import { ButtonGroup, Button, Label, Col, Row } from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { conditionConstants } from "../condition.constants";
import { deepClone } from "../../../../../helpers/objectHelper";

import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";
import { TextOverHeaderRow } from "../../../../../components/UI/Text/TextOverHeaderRow";
import { ExpansionPanel } from "@material-ui/core";
import './ConditionStyle.css'

class ConditionTypeList extends React.Component {
  isBtnActive = btn => {
    const { Show, Require, ReadOnly, CustomError } = conditionConstants.actions;
    const { element } = this.props;
    if (!element.data.checkCondition) {
      element.data.checkCondition = {};
      element.data.checkCondition[Show] = false;
      element.data.checkCondition[Require] = false;
      element.data.checkCondition[ReadOnly] = false;
      element.data.checkCondition[CustomError] = false;
    }
    switch (btn) {
      case "ShowAlways":
        if (element.data.checkCondition[Show] === false && element.data.hidden === false) {
          return "active";
        } else return "";
      case "ShowWhen":
        if (
          element.data.checkCondition[Show] === true &&
          element.data.conditions &&
          element.data.conditions.length > 0
        ) {
          return "active";
        } else return "";
      case "ShowNever":
        if (
 /*          element.data.checkCondition[Show] === false || */
          element.data.hidden === true
        ) {
          return "active";
        } else return "";
      case "RequireAlways":
        if (
          element.data.checkCondition[Require] === false &&
          element.data.required === true
        ) {
          return "active";
        } else return "";
      case "RequireWhen":
        if (
          element.data.checkCondition[Require] === true &&
          element.data.conditions &&
          element.data.conditions.length > 0
        ) {
          return "active";
        } else return "";
      case "RequireNever":
        if (
          element.data.checkCondition[Require] === false &&
          !element.data.required
        ) {
          return "active";
        } else return "";
      case "ReadonlyAlways":
        if (
          element.data.checkCondition[ReadOnly] === false &&
          element.data.readOnly === true
        ) {
          return "active";
        } else return "";
      case "ReadonlyWhen":
        if (
          element.data.checkCondition[ReadOnly] === true &&
          element.data.conditions &&
          element.data.conditions.length > 0
        ) {
          return "active";
        } else return "";
      case "ReadonlyNever":
        if (
          element.data.checkCondition[ReadOnly] === false &&
          !element.data.readOnly
        ) {
          return "active";
        } else return "";
      default:
        return "";
    }
  };
  handleClick = btn => {
    const {
      Show,
      Require,
      ReadOnly,
      CustomError
    } = conditionConstants.actions;
    const element = deepClone(this.props.element);
    if (!element.data.checkCondition) {
      element.data.checkCondition = {};
    }
    switch (btn) {
      case "ShowAlways":
        element.data.checkCondition[Show] = false;
        element.data.hidden = false;
        break;
      case "ShowWhen":
        element.data.checkCondition[Show] = true;
        break;
      case "ShowNever":
        element.data.hidden = true;
        break;
      case "RequireAlways":
        element.data.checkCondition[Require] = false;
        element.data.required = true;
        break;
      case "RequireWhen":
        element.data.checkCondition[Require] = true;
        break;
      case "RequireNever":
        element.data.checkCondition[Require] = false;
        element.data.required = false;
        break;
      case "ReadonlyAlways":
        element.data.checkCondition[ReadOnly] = false;
        element.data.readOnly = true;
        break;
      case "ReadonlyWhen":
        element.data.checkCondition[ReadOnly] = true;
        break;
      case "ReadonlyNever":
        element.data.checkCondition[ReadOnly] = false;
        element.data.readOnly = false;
        break;
      default:
        return;
    }
    /*     this.props.dispatch(elementActions.update(element)); */
    this.props.dispatch(formActions.updateFormElement(element));
  };
  render() {
    const {
      Show,
      Require,
      ReadoOnly,
      CustomError
    } = conditionConstants.actions;
    return (
      <div style={{ paddingTop: "10px" }}>
        <Row>
          <Col className="list-setting-item-title col-adjusted">
            <Label>
              <SystemLabel name="ShowThisElement" />
            </Label>
          </Col>
        </Row>
        <Row style={{ margin: '5px 0px' }}>
          <Col>
            <ButtonGroup className="condition-button-group" style={{ display: 'inline-block', border: '0px' }}>
              <Button
                className={this.isBtnActive("ShowAlways")}
                onClick={e => this.handleClick("ShowAlways")}
              >
                <SystemLabel name="Always" />
              </Button>
              <Button
                className={this.isBtnActive("ShowWhen")}
                onClick={e => {
                  this.handleClick("ShowWhen");
                  this.props.toggleConditionModal(Show);
                }}
              >
                <SystemLabel name="When" />
              </Button>
              <Button onClick={e => this.handleClick("ShowNever")} className={this.isBtnActive("ShowNever")}>
                <SystemLabel name="Never" />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row >
          <Col className="list-setting-item-title col-adjusted">
            <Label>
              <SystemLabel name="RequireThisElement" />
            </Label>
          </Col>
        </Row>
        <Row style={{ margin: '5px 0px' }}>
          <Col>
            <ButtonGroup className="condition-button-group" style={{ display: 'inline-block', border: '0px' }}>
              <Button className={this.isBtnActive("RequireAlways")}>
                <SystemLabel name="Always" />
              </Button>
              <Button className={this.isBtnActive("RequireWhen")}
                onClick={() => this.props.toggleConditionModal("RequireElement")}
              >
                <SystemLabel name="When" />
              </Button>
              <Button className={this.isBtnActive("RequireNever")}>
                <SystemLabel name="Never" />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row>
          <Col className="list-setting-item-title col-adjusted">
            <Label>
              <SystemLabel name="ElementIsReadOnly" />
            </Label>
          </Col>
        </Row>
        <Row style={{ margin: '5px 0px' }}>
          <Col>
            <ButtonGroup className="condition-button-group" style={{ display: 'inline-block', border: '0px' }}>
              <Button className={this.isBtnActive("ReadonlyAlways")}>
                <SystemLabel name="Always" />
              </Button>
              <Button className={this.isBtnActive("ReadonlyWhen")}
                onClick={() => this.props.toggleConditionModal("ReadOnlyElement")}
              >
                <SystemLabel name="When" />
              </Button>
              <Button className={this.isBtnActive("ReadonlyNever")}>
                <SystemLabel name="Never" />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>


      </div>
    );
  }
}

export default connect()(ConditionTypeList);
